import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { Student } from 'src/app/model/student/student.model';
import { JoinPipe } from 'src/app/pipes/join.pipe';
import { SchoolEnrollment } from '../model/school-enrollment.model';
import { StudentSchoolEnrollmentService } from './student-school-enrollment.service';
import { SearchStudent } from '../model/searchStudent';

@Injectable({
    providedIn: 'root'
})
export class StudentHelperService {
    private student = new BehaviorSubject<Student>(new Student());
    private searchStudent = new BehaviorSubject<SearchStudent>(new SearchStudent());
    private studentId = new BehaviorSubject<number>(0);
    private partyId = new BehaviorSubject<number>(0);
    private studentName = new BehaviorSubject<string>('');
    private msdNumber = new BehaviorSubject<string>('');
    private regions = new BehaviorSubject<string>('');
    private terminated = new BehaviorSubject<string>('');
    private merged = new BehaviorSubject<string>('');
    private isMerged = new BehaviorSubject<boolean>(false);

    student$ = this.student.asObservable();
    studentId$ = this.studentId.asObservable();
    partyId$ = this.partyId.asObservable();
    studentName$ = this.studentName.asObservable();
    msdNumber$ = this.msdNumber.asObservable();
    regions$ = this.regions.asObservable();
    searchStudent$ = this.searchStudent.asObservable();
    terminated$ = this.terminated.asObservable();
    merged$ = this.merged.asObservable();
    isMerged$ = this.isMerged.asObservable();

    joinPipe: JoinPipe = new JoinPipe();

    constructor(private titleService: Title, private studentSchoolEnrollmentService: StudentSchoolEnrollmentService) {}

    setStudent(student: Student) {
        this.student.next(student);
    }

    setStudentId(studentId: number) {
        this.studentId.next(studentId);
        this.partyId.next(0);
        this.studentName.next('');
        this.regions.next('');
        this.msdNumber.next('');
        this.merged.next('');
        this.isMerged.next(false);
        this.student.next(new Student());
        this.getSchoolEnrollments(studentId);
    }

    setPartyId(partyId: number) {
        this.partyId.next(partyId);
    }

    setStudentName(studentName: string) {
        this.studentName.next(studentName);

        if (this.titleService.getTitle().indexOf('View Child') >= 0 || this.titleService.getTitle().indexOf('Edit Child') >= 0) {
            this.titleService.setTitle(this.titleService.getTitle() + ' - ' + studentName);
        }
    }

    setMsdNumber(msdNumber: string) {
        this.msdNumber.next(msdNumber);
    }

    setRegions(regions: string) {
        this.regions.next(regions);
    }

    setSearchStudent(searchStudent: SearchStudent) {
        this.searchStudent.next(searchStudent);
    }

    setTerminated(terminated: string) {
        this.terminated.next(terminated ? ' - ' + terminated : '');
    }

    setMerged(merged: string) {
        this.merged.next(merged ? ' - ' + merged : '');
    }

    setIsMerged(isMerged: boolean) {
        this.isMerged.next(isMerged);
    }

    getSchoolEnrollments(studentId: number) {
        if (studentId > 0) {
            this.studentSchoolEnrollmentService.getSchoolEnrollments(studentId).subscribe((res) => {
                if (res.schoolEnrollments) {
                    let regions = this.joinPipe.transform(this.getRegions(res.schoolEnrollments), ', ', 'CODE');

                    if (regions.indexOf(',') >= 0) {
                        this.setRegions(' - Regions ( ' + regions + ' )');
                    } else {
                        this.setRegions(' - Region ( ' + regions + ' )');
                    }
                }
            });
        }
    }

    getRegions(schoolEnrollments: SchoolEnrollment[]) {
        let regions: any[] = [];

        schoolEnrollments.forEach((se) => {
            let regionIndex = regions.findIndex((r) => r.CODE === se.REGION.CODE);

            if (regionIndex === -1) {
                let region: any = se.REGION;
                regions.push(region);
            }
        });

        regions = regions.sort((a, b) => (a.CODE! > b.CODE! ? 1 : -1));

        return regions;
    }
}
